export default function isValidNumber(value: number | string) {
  return value !== '' && !Number.isNaN(+value);
}
